import { useState } from 'react';
import { useSnapshot } from 'valtio';
import type { Project } from '~/common/types';
import store from '~/pages/projectDetails/landRights/store';
import rootStore from '~/store';
import ZoningDialog from './ZoningDialog';

interface SelectedIdsProps extends Set<string> {
  data: string[];
}

interface Props {
  project?: Project;
}

export default function GetZoningInfoContainer({ project }: Props) {
  const { selectedIds } = useSnapshot(store);
  const [zoningDialogOpen, setZoningDialogOpen] = useState(false);

  const { currentOrganization } = useSnapshot(rootStore) as typeof rootStore;

  if (!currentOrganization?.subscription) return null;

  const { zoningAccess } = currentOrganization.subscription;

  const zoningDataAccess = zoningAccess !== 'none';

  return (
    <ZoningDialog
      zoningDialogOpen={zoningDialogOpen}
      setZoningDialogOpen={setZoningDialogOpen}
      zoningDataAccess={!!zoningDataAccess}
      selectedIds={(selectedIds as SelectedIdsProps).data.map((id: string) => {
        const split: string[] = id?.split('.') || [];
        split.shift();
        const _id = split.join('.');
        return _id;
      })}
      project={project}
    />
  );
}
